import React from 'react';
import { areOptionPropsEqual } from './areOptionPropsEqual';
import { SelectOption } from '../SelectOption';

const Option = ({
  data,
  isFocused,
  isCheckbox,
  innerRef,
  isDisabled,
  isSelected,
  lastSelected,
  preSelectedValues,
  ...rest
}) => {
  const isLastSelected = lastSelected && lastSelected.value === data.value;
  const isPreSelectedItem = preSelectedValues.some(
    item => item.value === data.value
  );

  return (
    <SelectOption
      value={data.value}
      label={data.label}
      secondaryText={data.secondaryText}
      BadgeProps={data.BadgeProps}
      actionProps={data.actionProps}
      isCheckbox={isCheckbox}
      isDisabled={isDisabled}
      isSelected={isSelected}
      isLastSelected={isLastSelected}
      isPreSelectedItem={isPreSelectedItem}
      isFocused={isFocused}
      ref={innerRef}
      {...rest}
    />
  );
};

/*
  This component is memoized due to a high render time of this component.
  When displaying in a list of 100+ items this can cause the browser to slow
  down and respond very poorly, therefore we only render options again when
  they change.
  If there are any issues with details on the option not updating it is probably
  related to the areOptionPropsEqual function that needs to check an additional
  parameter
 */
export default React.memo(Option, areOptionPropsEqual);
